export function Skeleton({ width = "100%", height = 16, borderRadius = 8, style }) {
  return (
    <div style={{
      width, height, borderRadius,
      background: "linear-gradient(90deg,#0d1f38 25%,#142a4a 50%,#0d1f38 75%)",
      backgroundSize: "200% 100%",
      animation: "skeletonShimmer 1.4s ease-in-out infinite",
      flexShrink: 0,
      ...style,
    }} />
  );
}

export function SkeletonCard({ rows = 3 }) {
  return (
    <div style={{ background: "#080f1e", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 14, padding: "18px 20px", display: "flex", flexDirection: "column", gap: 12 }}>
      <Skeleton height={14} width="60%" />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height={11} width={i === rows - 1 ? "40%" : "100%"} />
      ))}
      <style>{`@keyframes skeletonShimmer { 0%,100%{background-position:200% 0} 50%{background-position:-200% 0} }`}</style>
    </div>
  );
}
